import React from "react";
import Page from "../Page";
import BackButton from "../BackButton";
import ScrollToTop from "../ScrollToTop";

const PrivacyPolicy = () => {
  return (
    <Page>
      <ScrollToTop />
      <div style={{ display: "flex", alignItems: "center" }}>
        <BackButton />
        <h4 style={{ margin: "16px" }}>Політики приватності від 12.07.23</h4>
      </div>
      <strong>Використання файлів cookie</strong>
      <p>
        Розробники гри залишають за собою право збирати дані про відвідування
        веб-додатку або з’єднання, які проходять через додаток. Такі відомості
        можуть містити інформацію про Інтернет підключення, трафік та тривалість
        сеансу користувача в мережі Інтернет.
      </p>
      <p>
        Cookie – це текстовий файл або файли, що містять невеликий обсяг
        інформації, які надсилаються веб-браузеру і зберігаються на пристрої
        користувача.
      </p>
      <p>
        Щоб зробити відвідування веб-додатку зручнішим, відстежувати
        відвідування веб-додатку і покращувати сервіс, Товариство збирає
        невелику частину інформації, відправленої з вашого браузера, так звані
        файли Сookie.
      </p>
      <p>
        За бажанням користувач може не надсилати Сookie (така опція доступна у
        налаштуваннях вашого браузера). Однак, будь ласка, візьміть до уваги, що
        відключення функції відправки файлів Сookie обмежить можливості
        використання веб-додатку.{" "}
      </p>
      <p>
        Файли Сookie допомагають оцінити кількість і частоту запитів, а також
        виявляти і блокувати тих відвідувачів або пристрої, які намагаються
        виконати пакетні завантаження інформації з веб-додатку.
      </p>{" "}
      <p>
        Для оперативної доставки, більш якісного відображення і детального
        аналізу контенту у веб-додатку, Компанія користується послугами, які є
        власністю інших сторонніх компаній, таких як Google, NewRelic,
        OneSignal, Patreon.{" "}
      </p>
      <p>
        Наведені як приклад компанії можуть використовувати файли Cookie на
        пристрої користувача, під час роботи з веб-додатком. Слід звернути
        увагу, що веб-додаток не може вплинути на роботу файлів Cookie, які
        використовуються цими сервісами.{" "}
      </p>{" "}
      <p>
        Усі необхідні відомості про їх використання можна дізнатися за
        посиланнями:{" "}
      </p>
      <a
        href="https://policies.google.com/technologies/cookies?hl=en-US"
        target="_blank"
        rel="noreferrer"
      >
        Google Analytics
      </a>{" "}
      <br />
      <a
        href="https://newrelic.com/termsandconditions/cookie-policy"
        target="_blank"
        rel="noreferrer"
      >
        Newrelic
      </a>
      <br />
      <a
        href="https://onesignal.com/privacy_policy"
        target="_blank"
        rel="noreferrer"
      >
        OneSignal
      </a>{" "}
      <br />
      <a
        href="https://www.patreon.com/en-GB/policy/cookies"
        target="_blank"
        rel="noreferrer"
      >
        Patreon
      </a>
    </Page>
  );
};

export default PrivacyPolicy;
